/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const StyledContainer = styled.div``;
